import {Component, Inject} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {AlertService, AuthenticationService,} from '../../_services/index';

@Component({
    standalone: false,
    selector: 'message-component',
    templateUrl: 'message.component.html'
})

export class MessageComponent {
  text: string;
  title: string;
  button: string;
  constructor(
    public dialogRef: MatDialogRef<MessageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.text = data.text;
      this.title = data.title;
      this.button = data.button;
  }


  onClose(clicked: boolean): void {
      this.dialogRef.close(clicked);
  }
}
